import React from "react";

const Screen3 = () => {
  return (
    <>
      <div className="container mx-auto flex flex-col items-center gap-10">
        <div>
          <h2 className="text-yellow-500 font-bold text-5xl">About Us</h2>
        </div>

        <div>
          <h3 className="text-white font-extrabold text-4xl">
            Best Haircut Salon For Men
          </h3>
        </div>
        <div>
          <p className="text-white text-2xl">
            Let your hairdressers do their amazing job. Trim the hair to get
            your desired look. Book appointment with us for your favorite hair
            Styles!
          </p>
        </div>
      </div>
    </>
  );
};

export default Screen3;
